// accessories-calculator.js
// 立即执行函数，但不依赖于DOMContentLoaded事件
(function() {
    // 私有变量
    let accessoryHeightMap = {
        "Cat Step": 1.5,
        "Hammock": 3,
        "Transparent bubble": 1.5,
        "PA02-40cm(15.7in)":40,
        "PA04-30cm(11.8in)":30,
    };
    
    let isInitialized = false;
    let observer = null;

    // 私有函数 - 计算配件信息
    function calculateAccessoriesInfo() {
        const addedVariants = document.querySelectorAll('.lb-spc-added-variant');
        let accessoriesInfo = {};
        let totalAccessoriesHeight = 0;
        
        addedVariants.forEach(variant => {
            const titleElement = variant.querySelector('.lb-spc-added-variant-title');
            if (!titleElement) return;
            
            const title = titleElement.textContent.trim();
            
            const quantitySpan = variant.querySelector('span > span:nth-child(2)');
            const quantity = quantitySpan ? (parseInt(quantitySpan.textContent, 10) || 1) : 1;
            
            const singleHeight = accessoryHeightMap[title] || 0;
            const totalHeight = singleHeight * quantity;
            
            accessoriesInfo[title] = {
                singleHeight: singleHeight,
                quantity: quantity,
                totalHeight: totalHeight
            };
            
            totalAccessoriesHeight += totalHeight;
        });
        
        return {
            accessoriesInfo: accessoriesInfo,
            totalAccessoriesHeight: parseFloat(totalAccessoriesHeight.toFixed(2))
        };
    }

    // 初始化函数 - 设置观察者和事件监听
    function initialize() {
        if (isInitialized) return;
        
        // 创建MutationObserver实例
        observer = new MutationObserver((mutations) => {
            let shouldCalculate = false;
            
            mutations.forEach(mutation => {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1 && (
                            node.classList?.contains('lb-spc-added-variant') || 
                            node.querySelector?.('.lb-spc-added-variant')
                        )) {
                            shouldCalculate = true;
                        }
                    });
                    
                    mutation.removedNodes.forEach(node => {
                        if (node.nodeType === 1 && (
                            node.classList?.contains('lb-spc-added-variant') || 
                            node.querySelector?.('.lb-spc-added-variant')
                        )) {
                            shouldCalculate = true;
                        }
                    });
                }
                
                if (mutation.type === 'characterData') {
                    let node = mutation.target;
                    while (node && node !== document.body) {
                        if (node.classList && node.classList.contains('lb-spc-added-variant')) {
                            shouldCalculate = true;
                            break;
                        }
                        node = node.parentNode;
                    }
                }
                
                if (mutation.type === 'attributes') {
                    if (mutation.target.classList && mutation.target.classList.contains('lb-spc-added-variant')) {
                        shouldCalculate = true;
                    }
                }
            });
            
            if (shouldCalculate) {
                const result = calculateAccessoriesInfo();
                document.dispatchEvent(new CustomEvent('accessoriesInfoUpdated', { 
                    detail: result 
                }));
            }
        });

        // 配置观察选项
        const config = { 
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        };

        // 开始观察文档
        observer.observe(document.body, config);

        // 初始计算
        const result = calculateAccessoriesInfo();
        document.dispatchEvent(new CustomEvent('accessoriesInfoUpdated', { 
            detail: result 
        }));
        
        isInitialized = true;
        
        // 触发自定义事件，通知其他脚本计算器已初始化
        document.dispatchEvent(new CustomEvent('accessoriesCalculatorReady'));
        
        console.log('AccessoriesHeightCalculator initialized');
    }

    // 创建公共API
    const publicAPI = {
        // 初始化计算器
        init: function() {
            initialize();
            return this;
        },
        
        // 更新配件高度映射
        updateHeightMap: function(newMap) {
            accessoryHeightMap = {...newMap};
            
            if (isInitialized) {
                const result = calculateAccessoriesInfo();
                document.dispatchEvent(new CustomEvent('accessoriesInfoUpdated', { 
                    detail: result 
                }));
                return result;
            }
            return null;
        },
        
        // 手动触发计算
        calculate: function() {
            if (!isInitialized) {
                console.warn('AccessoriesHeightCalculator not initialized yet. Call init() first.');
                return null;
            }
            return calculateAccessoriesInfo();
        },
        
        // 导出为JSON
        exportAsJSON: function() {
            if (!isInitialized) {
                console.warn('AccessoriesHeightCalculator not initialized yet. Call init() first.');
                return '{}';
            }
            return JSON.stringify(calculateAccessoriesInfo(), null, 2);
        },
        
        // 获取当前配件高度映射
        getHeightMap: function() {
            return {...accessoryHeightMap};
        },
        
        // 销毁计算器，清理资源
        destroy: function() {
            if (observer) {
                observer.disconnect();
                observer = null;
            }
            isInitialized = false;
            console.log('AccessoriesHeightCalculator destroyed');
        }
    };

    // 将公共API暴露给全局
    window.AccessoriesHeightCalculator = publicAPI;
    
    // 注意：我们不在这里自动初始化，而是让调用者决定何时初始化
})();










// accessories-height-display.js
(function() {
    // 私有变量
    let heightDisplayElement = null;
    let isInitialized = false;
    let unit = 'cm';
    // 创建或获取显示元素
    function getOrCreateDisplayElement() {
        if (heightDisplayElement) return heightDisplayElement;
        
        const titleContainer = document.querySelector('.lb-upsell-ppa-title-cont');
        if (!titleContainer) return null;
        
        // 检查是否已经存在small元素
        let smallElement = titleContainer.querySelector('small');
        
        if (smallElement) {
            // 如果已存在，使用它
            heightDisplayElement = smallElement;
        } else {
            // 如果不存在，创建新元素
            heightDisplayElement = document.createElement('small');
            titleContainer.appendChild(heightDisplayElement);
        }
        
        // 添加基本样式
        heightDisplayElement.style.display = 'block';
        heightDisplayElement.style.marginTop = '8px';
        heightDisplayElement.style.color = 'rgb(102, 102, 102)';
        heightDisplayElement.style.fontWeight = 'normal';
        heightDisplayElement.style.fontSize = '0.85em';
        heightDisplayElement.style.lineHeight = '1.4';
        return heightDisplayElement;
    }
    
    // 更新高度显示
    function updateHeightDisplay(data) {
        const displayElement = getOrCreateDisplayElement();
        if (!displayElement) return;
        
        const totalHeight = data.totalAccessoriesHeight;
        
        // 根据高度设置不同的颜色
        let heightColor = '#666';
        if (totalHeight > 100) {
            heightColor = '#e67e22'; // 橙色警告
        } else if (totalHeight > 200) {
            heightColor = '#c0392b'; // 红色警告
        }
        
        // 更新显示内容
        displayElement.innerHTML = `Height: <strong style="color:#FFA200">+${totalHeight}${unit}</strong>`;
        
        displayElement.style.color = "black";
        displayElement.hidden = totalHeight <= 0;
    }
    
    // 初始化函数
    function initialize(localeUnit) {
        if (isInitialized) return;
        unit = localeUnit;
        // 监听高度更新事件
        document.addEventListener('accessoriesInfoUpdated', function(event) {
            updateHeightDisplay(event.detail);
        });
        
        isInitialized = true;
        console.log('AccessoriesHeightDisplay initialized');
    }
    
    // 创建公共API
    const publicAPI = {
        // 初始化显示模块
        init: function(localeUnit) {
            initialize(localeUnit);
            return this;
        },
        
        // 手动更新显示
        updateDisplay: function(data) {
            if (!isInitialized) {
                console.warn('AccessoriesHeightDisplay not initialized yet. Call init() first.');
                return;
            }
            updateHeightDisplay(data);
        },
        
        // 自定义显示格式
        setCustomFormat: function(formatFunction) {
            if (typeof formatFunction !== 'function') {
                console.error('Format must be a function');
                return;
            }
            
            // 替换默认的更新函数
            updateHeightDisplay = function(data) {
                const displayElement = getOrCreateDisplayElement();
                if (!displayElement) return;
                
                // 使用自定义格式函数
                formatFunction(displayElement, data);
            };
        },
        
        // 销毁显示模块
        destroy: function() {
            document.removeEventListener('accessoriesInfoUpdated', updateHeightDisplay);
            if (heightDisplayElement) {
                heightDisplayElement.remove();
                heightDisplayElement = null;
            }
            isInitialized = false;
            console.log('AccessoriesHeightDisplay destroyed');
        }
    };
    
    // 将公共API暴露给全局
    window.AccessoriesHeightDisplay = publicAPI;
})();
